/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyReturnBill } from 'app/shared/model/pharmacy-return-bill.model';
import { PaymentStatus } from 'app/shared/model/enumerations/payment-status.model';

export interface IPharmacyReturnBillPayment {
  id?: string;
  paymentMethod?: string | null;
  transactionDetails?: string | null;
  paidAmount?: number | null;
  active?: boolean | null;
  cursor?: number | null;
  timestampEntry?: number | null;
  microSec?: number | null;
  lastUpdated?: number | null;
  paymentStatus?: keyof typeof PaymentStatus | null;
  forCredit?: boolean | null;
  refundBill?: IPharmacyReturnBill | null;
}

export const defaultValue: Readonly<IPharmacyReturnBillPayment> = {
  active: false,
  forCredit: false,
};
